import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => (path ? `${API}${path}` : "");

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const get = (url, config) => client.get(url, config).then((r) => r.data);
export const post = (url, body, config) => client.post(url, body, config).then((r) => r.data);
export const put = (url, body) => client.put(url, body).then((r) => r.data);
export const del = (url) => client.delete(url).then((r) => r.data);

export const upload = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export default client;
